import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NzSkeletonElementAvatarComponent } from "ng-zorro-antd/skeleton";
import { UiSkeletonAvatarShape, UiSkeletonAvatarSize } from "@webapp/ui/skeleton/skeleton.type";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-skeleton-element[skeletonType="avatar"]',
  templateUrl: "skeleton-element-avatar.component.html",
})
export class UiSkeletonElementAvatarComponent extends NzSkeletonElementAvatarComponent {
  @Input("uiShape") public nzShape: UiSkeletonAvatarShape = "circle";
  @Input("uiSize") public nzSize: UiSkeletonAvatarSize = "default";
}
